import React from 'react';
import { hot } from 'react-hot-loader';
import { unique } from '../../utils/array';
import s from './Price.scss';

const Price = ({ price, priceRange = [], soldOut = false, isProduct = false, isProductItem = false }) => {
	const isOnSale = price.showAsOnSale || price.priceAsNumber !== price.priceBeforeDiscountAsNumber;
	const hasPriceRange = Object.keys(priceRange).length > 0 && unique(priceRange.map((p) => p.price)).length > 1;
	const priceClasses = [s.price];
	if (isProductItem) priceClasses.push(s.price__productItem);
	if (isProduct) priceClasses.push(s.price__product);

	if (hasPriceRange) {
		const topBottomPrice = priceRange.filter((p, i) => i === 0 || i === priceRange.length - 1);
		return (
			soldOut ? (
				<span className={priceClasses.join(' ')}>{ soldOut }</span>
			) : (
				<span className={[...priceClasses, !isProduct ? s.price__range : null].join(' ')}>{ isOnSale ? <s className={s.price_strikeThrough}>{ topBottomPrice.map((p) => p.priceBeforeDiscount).join(' - ') }</s> : topBottomPrice.map((p) => p.price).join(' - ') } { isOnSale ? <span className={s.price_sale}>{topBottomPrice.map((p) => p.price).join(' - ')}</span> : null }</span>
			)
		);
	}
	return (
		soldOut ? (
			<span className={priceClasses.join(' ')}>{ soldOut }</span>
		) : (
			<span className={priceClasses.join(' ')}>{ isOnSale ? <s className={s.price_strikeThrough}>{ price.priceBeforeDiscount }</s> : price.price } { isOnSale ? <span className={s.price_sale}>{price.price}</span> : null }</span>
		)
	);
};

export default hot(module)(Price);
